import { render, staticRenderFns } from "./BusinessDialog.vue?vue&type=template&id=53fe8680&scoped=true"
import script from "./BusinessDialog.vue?vue&type=script&lang=js"
export * from "./BusinessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe8680",
  null
  
)

export default component.exports